import { useEffect } from "react";
import { useLocation } from "react-router";
import { submitView } from "@platform/browser-logger";

function consultingViewForPath(pathname: string): string | null {
  if (pathname === "/consulting" || pathname === "/consulting/") {
    return "consulting.home";
  }

  if (/^\/consulting\/[^/]+\/stewardship-report\/?$/.test(pathname)) {
    return "consulting.stewardship_report";
  }

  return null;
}

export function ConsultingRouteTracking(): null {
  const { pathname } = useLocation();

  useEffect(() => {
    const title = consultingViewForPath(pathname);
    if (!title) {
      return;
    }

    submitView({ path: pathname, title });
  }, [pathname]);

  return null;
}
